import React from "react";
import { FaPhone } from "react-icons/fa";

export default function PhoneIcon({ size }) {
  return <FaPhone size={size} />;
}

PhoneIcon.defaultProps = {
  size: 18,
};
